import { render, staticRenderFns } from "./modelDialog.vue?vue&type=template&id=6c56ff0d&scoped=true"
import script from "./modelDialog.vue?vue&type=script&lang=js"
export * from "./modelDialog.vue?vue&type=script&lang=js"
import style0 from "./modelDialog.vue?vue&type=style&index=0&id=6c56ff0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c56ff0d",
  null
  
)

export default component.exports